"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reliability = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _reliability = require("../../types/reliability");
var styles = _interopRequireWildcard(require("./Reliability.css"));
var _List = require("./inner/List");
var _Item = require("./inner/Item");
var _Header = require("./inner/Header");
var _Footer = require("./inner/Footer");
var _uiKit = require("@cian/ui-kit");
var _Status = require("./inner/Status");
var _ItemEscrow = require("./inner/ItemEscrow");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Компонент надежности
 */
const Reliability = props => /*#__PURE__*/React.createElement("div", {
  className: styles['container']
}, /*#__PURE__*/React.createElement("div", {
  className: styles['header']
}, /*#__PURE__*/React.createElement(_Header.Header, {
  title: "\u041D\u0430\u0434\u0451\u0436\u043D\u043E\u0441\u0442\u044C \u0416\u041A",
  date: props.date
})), /*#__PURE__*/React.createElement("div", {
  className: styles['status']
}, /*#__PURE__*/React.createElement(_Status.Status, {
  status: props.status,
  title: props.title
})), /*#__PURE__*/React.createElement("div", {
  className: styles['main']
}, /*#__PURE__*/React.createElement(_List.List, null, props.details.map(item => item.type === _reliability.EReliabilityDetailType.Escrow ? /*#__PURE__*/React.createElement(_ItemEscrow.ItemEscrow, (0, _extends2.default)({
  key: item.type
}, item, {
  onEscrowButtonClick: props.onEscrowButtonClick
})) : /*#__PURE__*/React.createElement(_Item.Item, (0, _extends2.default)({
  key: item.type
}, item))))), /*#__PURE__*/React.createElement("div", {
  className: styles['footer']
}, /*#__PURE__*/React.createElement(_Footer.Footer, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
  onClick: props.onDetailsClick,
  fullWidth: true,
  size: "M",
  theme: "fill_secondary"
}, props.actions.details || 'Подробнее'))));
exports.Reliability = Reliability;